import React from "react"
import { Button, Divider, Grid, TextField } from "@material-ui/core"
import BlockBodySectionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionEditor"
import useContentEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useContentEditor"
import { ChatBotFlowBlockContent } from "@/protocols/chatBot"
import { Add as AddIcon } from "@material-ui/icons"
import DeleteButton from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/DeleteButton"

type APIBlockHeaderSectionEditorProps = {
	onSave: (chatBotFlowBlockContent: ChatBotFlowBlockContent) => void
	chatBotFlowBlockContent: ChatBotFlowBlockContent
}

const APIBlockHeaderSectionEditor: React.FC<APIBlockHeaderSectionEditorProps> = ({
	chatBotFlowBlockContent,
	onSave,
	children
}) => {
	const contentEditor = useContentEditor({ chatBotFlowBlockContent })
	const apiBlock = contentEditor.content?.apiBlock
	const headers = apiBlock?.headers || []
	const hasMultipleHeaders = headers.length > 1

	const handleChange = (index: number, field: "key" | "value", newValue: string) => {
		const updatedHeaders = [...headers]
		updatedHeaders[index] = {
			...updatedHeaders[index],
			[field]: newValue
		}

		contentEditor.changeContent({
			apiBlock: {
				...apiBlock,
				headers: updatedHeaders
			}
		})
	}

	const handleAdd = () => {
		const updatedHeaders = [...headers, { key: "", value: "" }]
		contentEditor.changeContent({
			apiBlock: {
				...apiBlock,
				headers: updatedHeaders
			}
		})
	}

	const handleOpen = () => {
		contentEditor.reset()
	}

	const handleRemoveHeaderOption = (index: number) => {
		const updated = [...headers]
		updated.splice(index, 1)

		contentEditor.changeContent({
			apiBlock: {
				...apiBlock,
				headers: updated
			}
		})
	}

	const handleSave = () => {
		onSave(contentEditor.content)
	}

	return (
		<BlockBodySectionEditor
			title="Configurações do corpo da requisição"
			onSave={handleSave}
			onOpen={handleOpen}
			AsideDrawerProps={{
				children: (
					<Grid container direction="column" spacing={2} alignItems="flex-end">
						<Grid item xs={12}>
							<Grid container spacing={2} justifyContent="flex-end">
								{headers.map((header, index) => {
									return (
										<Grid item xs={12} key={index}>
											<Grid container alignItems="center" spacing={1}>
												<Grid item xs={12}>
													<TextField
														variant="outlined"
														placeholder="Key"
														fullWidth
														value={header.key}
														onChange={e => handleChange(index, "key", e.target.value)}
													/>
												</Grid>
												<Grid item xs={12}>
													<TextField
														variant="outlined"
														placeholder="Value"
														fullWidth
														value={header.value}
														onChange={e => handleChange(index, "value", e.target.value)}
													/>
												</Grid>
												<Grid item xs={12}>
													<Grid
														container
														alignItems="center"
														justifyContent="flex-end"
													>
														<DeleteButton
															onClick={() => handleRemoveHeaderOption(index)}
														/>
													</Grid>
												</Grid>
												{hasMultipleHeaders && (
													<Grid item xs={12}>
														<Divider />
													</Grid>
												)}
											</Grid>
										</Grid>)
								})}
							</Grid>
						</Grid>
						<Grid item xs={12}>
							<Button
								variant="text"
								color="primary"
								onClick={handleAdd}
								style={{ height: 40, fontSize: 14 }}
								startIcon={<AddIcon />}
							>
								Adicionar cabeçalho
							</Button>
						</Grid>
					</Grid>
				)
			}}
		>
			{children}
		</BlockBodySectionEditor>
	)
}

export default APIBlockHeaderSectionEditor
